<template>
  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
       width="46px" height="38px" viewBox="0 0 46 38" enable-background="new 0 0 46 38" xml:space="preserve">
<path fill="#FFFFFF" d="M23.211,5.791c-6.918,0-12.545,5.626-12.545,12.541c0,1.914,0.444,3.829,1.287,5.542l0.025,0.054
	l-0.018,0.056l-2.158,6.439c-0.125,0.374-0.03,0.782,0.251,1.063c0.277,0.277,0.702,0.376,1.063,0.251l6.503-2.174l0.054,0.025
	c1.709,0.841,3.623,1.286,5.537,1.286c6.914,0,12.541-5.627,12.541-12.543C35.752,11.417,30.125,5.791,23.211,5.791z M23.211,28.794
	c-1.751,0-3.48-0.439-5.002-1.27c-0.254-0.137-0.561-0.167-0.828-0.073l-4.943,1.653l1.655-4.938
	c0.091-0.274,0.063-0.574-0.075-0.828c-0.831-1.525-1.271-3.256-1.271-5.007c0-5.767,4.692-10.46,10.464-10.46
	c5.767,0,10.46,4.693,10.46,10.46C33.671,24.102,28.978,28.794,23.211,28.794z M17.815,21.708c-0.033-0.247,0.031-0.49,0.183-0.688
	c0.15-0.198,0.369-0.323,0.617-0.356c1.074-0.146,1.904-1,2.017-2.079l0.017-0.159h-1.932c-0.515,0-0.934-0.418-0.934-0.931v-1.648
	c0-0.514,0.419-0.932,0.934-0.932h2.857c0.513,0,0.932,0.417,0.932,0.932v2.496c0,2.098-1.566,3.888-3.647,4.165
	C18.358,22.575,17.879,22.21,17.815,21.708z M24.333,21.708c-0.032-0.247,0.033-0.49,0.184-0.688
	c0.151-0.198,0.37-0.323,0.616-0.356c1.075-0.146,1.904-1,2.017-2.079l0.018-0.159h-1.933c-0.513,0-0.932-0.418-0.932-0.931v-1.648
	c0-0.514,0.419-0.932,0.932-0.932h2.857c0.514,0,0.933,0.417,0.933,0.932v2.496c0,2.098-1.567,3.888-3.647,4.165
	C24.877,22.575,24.397,22.21,24.333,21.708z"/>
</svg>
</template>

<script>
    export default {
        name: "CiteThisIcon"
    }
</script>

<style scoped>

</style>